import { RECEIVE_CURRENT_AGENT } from 'agent_portal/actions/CurrentAgentActions';

const CurrentAgentReducer = (state = {}, action) => {
  if (action.type === RECEIVE_CURRENT_AGENT) {
    return action.currentAgent;
  }
  return state;
};

export default CurrentAgentReducer;
